import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Operario/getFiltrarOperario`, method: 'POST', body: values, token: token})
}
